import { createModel } from "@rematch/core";
import { DashboardFilterState, PostalcodesState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, multiRequest, signoutIfUnauthorized } from "./utilities";

const initialState: PostalcodesState = {
  features: [],
  loading: false,
  pending: null,
  type: "FeatureCollection",
};

export const postalcodes = createModel<RootModel>()({
  state: initialState as PostalcodesState,
  reducers: {
    fetchPending(state, requestId: string) {
      return multiRequest.updatePending(state, requestId);
    },
    fetchSuccess(state, payload: Partial<PostalcodesState>, requestId: string) {
      return multiRequest.updateSuccess(payload, state, requestId);
    },
    fetchFail(state, requestId: string) {
      return multiRequest.updateFail(state, requestId);
    },
  },
  effects: (dispatch) => ({
    async fetchPostalcodes(dashboardFilter: DashboardFilterState, rootState) {
      const requestId = multiRequest.getRequestId();
      dispatch.postalcodes.fetchPending(requestId);

      const token = checkToken(rootState, () =>
        dispatch.postalcodes.fetchFail(requestId)
      );
      if (!token) return;

      try {
        const postalcodesResult = await api.fetchPostalcodes(
          token,
          dashboardFilter
        );
        dispatch.postalcodes.fetchSuccess(postalcodesResult, requestId);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.postalcodes.fetchFail(requestId);
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/postalcodes.ts